export default __webpack_public_path__ + "static/media/gray_arrow_distributor.4f581ba4.png";